export const PROVIDER_TYPES = {
  WISTIA: 'WISTIA',
};

export const VIEWED_THRESHOLD = 0.95;
export const NOTIFICATION_INTERVAL = 15; //seconds
export const VIDEO_PROGRESS = {
  STARTED: 'STARTED',
  NOT_STARTED: 'NOTSTARTED',
  COMPLETE: 'COMPLETE',
};
